<template>
  <div>
    <div class="d-flex flex-row">
      <div
        class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
        id="kt_profile_aside"
      >
        <div class="card card-custom card-stretch">
          <div class="card-body pt-4">
            <div class="d-flex justify-content-end">
              <KTDropdown2></KTDropdown2>
            </div>
            <div class="d-flex align-items-center">
              <div
                class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
              >
                <div
                  class="symbol-label"
                  :style="{
                    backgroundImage: `url(media/users/300_21.jpg})`,
                  }"
                ></div>
                <i class="symbol-badge bg-success"></i>
              </div>
              <div>
                <a
                  class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                  >{{ currentUser.username }}</a
                >
                <div class="text-muted">欢迎使用蜜蜂代理产品</div>
                <div class="mt-2">
                  <a
                    class="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                    @click="rechargeDialog = true"
                    >充值</a
                  >

                  <a
                    class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                    @click="requestResetToken"
                    >重置token</a
                  >
                </div>
              </div>
            </div>
            <!--end::User-->
            <!--begin::Contact-->
            <div class="py-9">
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">token: </span>
                <span class="text-muted">{{ currentUser.token }}</span>
                <!--                <a class="text-muted text-hover-primary">{{-->
                <!--                  -->
                <!--                }}</a>-->
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">邮箱:</span>
                <span class="text-muted">{{ currentUser.email }}</span>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-weight-bold mr-2">手机号码:</span>
                <span class="text-muted">{{ currentUser.phone }}</span>
              </div>
            </div>
            <!--end::Contact-->
            <!--begin::Nav-->
            <div
              class="navi navi-bold navi-hover navi-active navi-link-rounded"
              role="tablist"
            >
              <div class="navi-item mb-2">
                <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor: pointer"
                  data-tab="0"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="navi-icon mr-2">
                    <span class="svg-icon">
                      <inline-svg
                        src="/oms/media/svg/icons/Design/Layers.svg"
                      />
                    </span>
                  </span>
                  <span class="navi-text font-size-lg">用户总览</span>
                </a>
              </div>
              <div class="navi-item mb-2">
                <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor: pointer"
                  data-tab="1"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="navi-icon mr-2">
                    <span class="svg-icon">
                      <inline-svg src="/oms/media/svg/icons/General/User.svg" />
                    </span>
                  </span>
                  <span class="navi-text font-size-lg">用户信息</span>
                </a>
              </div>

              <div class="navi-item mb-2">
                <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor: pointer"
                  data-tab="2"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="navi-icon mr-2">
                    <span class="svg-icon">
                      <inline-svg
                        src="/oms/media/svg/icons/Communication/Shield-user.svg"
                      />
                    </span>
                  </span>
                  <span class="navi-text font-size-lg">更改密码</span>
                </a>
              </div>

              <div class="navi-item mb-2">
                <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor: pointer"
                  data-tab="3"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="navi-icon mr-2">
                    <span class="svg-icon">
                      <inline-svg
                        src="/oms/media/svg/icons/Communication/Shield-user.svg"
                      />
                    </span>
                  </span>
                  <span class="navi-text font-size-lg">实名认证</span>
                </a>
              </div>
            </div>
            <!--end::Nav-->
          </div>
        </div>
      </div>
      <!--begin::Content-->
      <div class="flex-row-fluid ml-lg-8">
        <b-tabs v-model="tabIndex">
          <b-tab title="用户总览">
            <div class="row">
              <div class="col-lg-6">
                <ExpendDashboard></ExpendDashboard>
              </div>
              <div class="col-lg-6">
                <Widget14></Widget14>
              </div>
            </div>
            <!--end::Row-->
          </b-tab>

          <b-tab title="用户信息">
            <KTPersonalInformation></KTPersonalInformation>
          </b-tab>

          <b-tab title="更改密码">
            <KTChangePassword></KTChangePassword>
          </b-tab>

          <b-tab title="实名认证">
            <Wizard1></Wizard1>
          </b-tab>
        </b-tabs>
      </div>
      <Recharge v-bind:dialog.sync="rechargeDialog"></Recharge>
      <TestService v-bind:dialog.sync="testServiceDialog"></TestService>
    </div>
  </div>
</template>

<script>
import Recharge from "@/view/pages/pay/Recharge";
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import KTPersonalInformation from "@/view/pages/profile/PersonalInformation";
import KTChangePassword from "@/view/pages/profile/ChangePassword";
import ExpendDashboard from "@/view/pages/profile/ExpendDashboard";
import Widget14 from "@/view/pages/profile/Widget14";
import Wizard1 from "@/view/pages/profile/Wizard-1";
import TestService from "@/view/pages/pay/TestService";
import { mapGetters } from "vuex";
import { RESET_CUSTOM_TOKEN } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "dashboard",
  components: {
    Wizard1,
    Recharge,
    KTChangePassword,
    KTDropdown2,
    KTPersonalInformation,
    ExpendDashboard,
    Widget14,
    TestService,
  },
  data() {
    return {
      tabIndex: 1,
      rechargeDialog: false,
      testServiceDialog: false,
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.tabIndex = this.$route.query.tab;
    } else {
      this.tabIndex = 0;
    }
  },
  mounted() {
    if (this.currentUser.is_verify) {
      if (this.$route.query.code) {
        this.testServiceDialog = true;
      }
    } else {
      Swal.fire({
        title: "实名认证提醒",
        text: "需实名认证后才能使用蜜蜂代理服务！",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          this.tabIndex = 3;
        }
      });
    }
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      this.testServiceDialog = false;
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    },
    requestResetToken() {
      this.$bvModal
        .msgBoxConfirm(
          "重置 token 后，您需要重新生成和配置 API，请确认后操作。",
          {
            title: "提醒消息",
            okVariant: "warning",
            okTitle: "确定",
            cancelTitle: "取消",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((val) => {
          if (val) {
            this.$store.dispatch(RESET_CUSTOM_TOKEN).then(() => {
              this.$bvToast.toast("重置 token 成功", {
                title: "",
                variant: "success",
                toaster: "b-toaster-top-center",
              });
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>
